(function () {
  var eur = function (cents) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  };
  var wishKey = 'nay-wish';
  var wishes = [];
  try { wishes = JSON.parse(localStorage.getItem(wishKey) || '[]'); } catch (e) { wishes = []; }

  function saveWish() { localStorage.setItem(wishKey, JSON.stringify(wishes)); }
  function paintWish() {
    document.querySelectorAll('[data-nay-wish]').forEach(function (button) {
      button.classList.toggle('is-on', wishes.indexOf(String(button.getAttribute('data-nay-wish'))) !== -1);
    });
  }

  var toast = document.querySelector('[data-nay-toast]');
  var toastTimer;
  function showToast(name) {
    if (!toast) return;
    var msg = toast.querySelector('[data-nay-toast-msg]');
    if (msg) msg.textContent = name || '';
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 3200);
  }

  // --- Compte a rebours d'offre -------------------------------------------
  // Une seule date de fin, reglee dans l'editeur de theme, partagee par tous
  // les blocs [data-nay-deadline]. Elle est absolue : le compteur ne repart
  // jamais de zero au rechargement, et tout disparait une fois la date passee.
  (function () {
    var nodes = document.querySelectorAll('[data-nay-deadline]');
    if (!nodes.length) return;

    // "AAAA-MM-JJ HH:MM" saisi en heure de Paris.
    var parseDeadline = function (raw) {
      var m = String(raw || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
      if (!m) return null;
      var y = +m[1], mo = +m[2], d = +m[3], h = m[4] === undefined ? 23 : +m[4], mi = m[5] === undefined ? 59 : +m[5];
      // Paris : UTC+2 a l'heure d'ete (dernier dimanche de mars -> dernier
      // dimanche d'octobre), UTC+1 le reste de l'annee.
      var utcGuess = Date.UTC(y, mo - 1, d, h, mi);
      var lastSunday = function (year, month) {
        var last = new Date(Date.UTC(year, month + 1, 0));
        return Date.UTC(year, month, last.getUTCDate() - last.getUTCDay(), month === 2 ? 1 : 1);
      };
      var summer = utcGuess >= lastSunday(y, 2) && utcGuess < lastSunday(y, 9);
      return utcGuess - (summer ? 2 : 1) * 3600000;
    };

    var pad = function (n) { return String(n).padStart(2, '0'); };

    // Le compteur ne s'affiche que dans les derniers jours. Au-dela, un
    // "26 jours" donne a la cliente une raison d'attendre : on ne montre
    // que le nom de l'offre, et les chiffres arrivent quand ca compte.
    var countdownWindowDays = Number(document.documentElement.getAttribute('data-nay-countdown-days') || 3);

    var render = function () {
      var now = Date.now();
      var stillRunning = false;
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var end = parseDeadline(node.getAttribute('data-nay-deadline'));
        var out = node.querySelector('[data-nay-deadline-time]');
        var label = node.querySelector('[data-nay-deadline-label]');
        if (!end || end <= now) { node.hidden = true; continue; }
        stillRunning = true;
        node.hidden = false;
        var left = Math.floor((end - now) / 1000);
        var withinWindow = left <= countdownWindowDays * 86400;
        if (label) label.hidden = !withinWindow;
        if (out) out.hidden = !withinWindow;
        if (!out || !withinWindow) continue;
        var hours = Math.floor(left / 3600);
        var mins = Math.floor((left % 3600) / 60);
        var secs = left % 60;
        out.textContent = pad(hours) + ':' + pad(mins) + ':' + pad(secs);
      }
      if (!stillRunning) clearInterval(deadlineTimer);
    };

    render();
    var deadlineTimer = setInterval(render, 1000);
  })();

  var funnel = document.querySelector('[data-nay-funnel]');
  var funnelLines = funnel && funnel.querySelector('[data-nay-lines]');
  var funnelCount = funnel && funnel.querySelector('[data-nay-count]');
  var funnelTotal = funnel && funnel.querySelector('[data-nay-total]');
  var funnelShip = funnel && funnel.querySelector('[data-nay-ship]');
  var funnelFill = funnel && funnel.querySelector('[data-nay-fill]');
  var funnelSavings = funnel && funnel.querySelector('[data-nay-savings]');
  var funnelOffers = funnel && funnel.querySelector('[data-nay-offers]');
  var headerCount = document.querySelector('[data-nay-count-badge]');
  var offers = [];
  var offersNode = document.getElementById('nay-offers');
  if (offersNode) { try { offers = JSON.parse(offersNode.textContent); } catch (e) { offers = []; } }

  function openFunnel() {
    if (!funnel) return;
    funnel.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    loadCart();
  }
  function closeFunnel() {
    if (!funnel) return;
    funnel.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    var count = cart.item_count || 0;
    if (headerCount) {
      headerCount.textContent = count;
      headerCount.hidden = count < 1;
    }
    if (funnelCount) funnelCount.textContent = '(' + count + ' article' + (count > 1 ? 's' : '') + ')';
    if (funnelTotal) funnelTotal.textContent = 'Paiement · ' + eur(cart.total_price || 0);
    var free = 3400;
    var left = Math.max(0, free - (cart.total_price || 0));
    if (funnelShip) {
      funnelShip.innerHTML = left === 0
        ? 'Votre commande bénéficie de la livraison offerte'
        : 'Plus que <b>' + eur(left) + '</b> pour la livraison offerte';
    }
    if (funnelFill) funnelFill.style.width = Math.min(100, ((cart.total_price || 0) / free) * 100) + '%';
    var savings = 0;
    (cart.items || []).forEach(function (item) {
      if (item.original_line_price > item.final_line_price) savings += item.original_line_price - item.final_line_price;
    });
    if (funnelSavings) {
      funnelSavings.hidden = savings <= 0;
      var amount = funnelSavings.querySelector('b');
      if (amount) amount.textContent = eur(savings);
    }
    if (!funnelLines) return;
    if (!cart.items || !cart.items.length) {
      funnelLines.innerHTML = '<p class="nay-empty">Votre panier est vide</p>';
    } else {
      funnelLines.innerHTML = cart.items.map(function (item) {
        return '<div class="nay-funnel__line"><img src="' + (item.image || '') + '" alt=""><div><b>' + item.product_title + '</b><div>' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div><div class="nay-funnel__qty"><button type="button" data-nay-qty="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button><span>' + item.quantity + '</span><button type="button" data-nay-qty="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button><button class="nay-funnel__remove" type="button" data-nay-qty="' + item.key + '" data-qty="0">Retirer</button></div></div><div><b>' + eur(item.final_line_price) + '</b></div></div>';
      }).join('');
    }
    if (funnelOffers) {
      var inCart = (cart.items || []).map(function (item) { return item.variant_id; });
      var extra = offers.filter(function (offer) { return inCart.indexOf(offer.id) === -1; });
      funnelOffers.innerHTML = extra.length ? extra.map(function (offer) {
        return '<div class="nay-offer"><img src="' + (offer.image || '') + '" alt=""><div><span>' + offer.hook + '</span><b>' + offer.title + '</b><span style="color:var(--nay-text-strong);font-size:14px">' + eur(offer.price) + '</span><button type="button" data-nay-add="' + offer.id + '" data-nay-name="' + offer.title + '">Ajouter</button></div></div>';
      }).join('') : '';
      var offersWrap = funnel.querySelector('[data-nay-offers-wrap]');
      if (offersWrap) offersWrap.hidden = extra.length === 0;
    }
  }

  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (body) { throw body; });
      return r.json();
    }).then(function () { return loadCart(); });
  }

  document.addEventListener('click', function (event) {
    var wish = event.target.closest('[data-nay-wish]');
    if (wish) {
      event.preventDefault();
      var id = String(wish.getAttribute('data-nay-wish'));
      var index = wishes.indexOf(id);
      if (index === -1) wishes.push(id); else wishes.splice(index, 1);
      saveWish();
      paintWish();
      return;
    }
    var add = event.target.closest('[data-nay-add]');
    if (add && !add.closest('[data-ndp]')) {
      event.preventDefault();
      addItems([{ id: Number(add.getAttribute('data-nay-add')), quantity: 1 }]).then(function () {
        showToast(add.getAttribute('data-nay-name'));
      });
      return;
    }
    if (event.target.closest('[data-nay-cart]')) {
      event.preventDefault();
      openFunnel();
    }
    if (event.target.closest('[data-nay-funnel-close]')) closeFunnel();
    var qty = event.target.closest('[data-nay-qty]');
    if (qty) changeQty(qty.getAttribute('data-nay-qty'), Number(qty.getAttribute('data-qty')));
    if (event.target.closest('[data-nay-toast-cart]')) { if (toast) toast.classList.remove('is-on'); openFunnel(); }
    if (event.target.closest('[data-nay-toast-close]')) { if (toast) toast.classList.remove('is-on'); }
    var railBtn = event.target.closest('[data-ndh-rail-btn]');
    if (railBtn) {
      var rail = railBtn.closest('[data-ndh-rail]');
      var scroller = rail && rail.querySelector('[data-ndh-scroller]');
      if (scroller) {
        var card = scroller.querySelector('.nay-card:not(.is-hidden)');
        var step = card ? card.getBoundingClientRect().width + 20 : scroller.clientWidth * 0.75;
        scroller.scrollBy({ left: railBtn.getAttribute('data-ndh-rail-btn') === 'next' ? step : -step, behavior: 'smooth' });
      }
    }
    var tab = event.target.closest('[data-nay-tab]');
    if (tab) {
      var wrap = tab.parentElement;
      wrap.querySelectorAll('[data-nay-tab]').forEach(function (button) { button.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var value = tab.getAttribute('data-nay-tab');
      document.querySelectorAll('.nay-card[data-cat]').forEach(function (card) {
        if (!card.closest('#MainContent')) return;
        card.classList.toggle('is-hidden', value !== 'Tout' && card.getAttribute('data-cat') !== value);
      });
      var homeScroller = document.querySelector('[data-ndh-scroller]');
      if (homeScroller) homeScroller.scrollTo({ left: 0, behavior: 'smooth' });
    }
    var vegan = event.target.closest('[data-nay-vegan]');
    if (vegan) {
      document.querySelectorAll('.nay-card[data-vegan]').forEach(function (card) {
        card.classList.toggle('is-hidden', vegan.checked && card.getAttribute('data-vegan') !== 'true');
      });
    }
  });

  function initProduct(root) {
    var variants = [];
    var data = root.querySelector('[data-ndp-variants]');
    if (data) { try { variants = JSON.parse(data.textContent); } catch (e) { variants = []; } }
    var selected = variants[0] || null;
    var bundleQty = 2;
    var picks = [0, 0, 0, 0];
    var main = root.querySelector('[data-ndp-main]');
    var track = root.querySelector('[data-ndp-track]');
    var slides = root.querySelectorAll('[data-ndp-slide]');
    var thumbs = root.querySelectorAll('[data-ndp-thumb]');
    var index = 0;

    var stage = main && main.closest('.ndp-stage');
    function detectPackshot() {
      if (!stage || !main.complete || !main.naturalWidth) return;
      try {
        var size = 48;
        var canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(main, 0, 0, size, size);
        var corners = [[1, 1], [size - 2, 1], [1, size - 2], [size - 2, size - 2], [1, size >> 1], [size - 2, size >> 1]].map(function (p) {
          return ctx.getImageData(p[0], p[1], 1, 1).data;
        });
        var uniform = corners.every(function (c) {
          return Math.abs(c[0] - corners[0][0]) < 6 && Math.abs(c[1] - corners[0][1]) < 6 && Math.abs(c[2] - corners[0][2]) < 6 && c[0] + c[1] + c[2] > 720;
        });
        stage.classList.toggle('is-packshot', uniform);
        if (uniform) stage.style.setProperty('--ndp-stage-bg', 'rgb(' + corners[0][0] + ',' + corners[0][1] + ',' + corners[0][2] + ')');
      } catch (e) {
        stage.classList.remove('is-packshot');
      }
    }
    if (main) {
      main.addEventListener('load', detectPackshot);
      if (main.complete) detectPackshot();
    }

    function syncActiveThumb(nextIndex) {
      index = nextIndex;
      thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === index); });
      var strip = thumbs[index] && thumbs[index].parentElement;
      if (!strip || !thumbs[index]) return;
      var left = thumbs[index].offsetLeft - (strip.clientWidth - thumbs[index].offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
    }

    function showImage(next) {
      var total = slides.length || thumbs.length;
      if (!total) return;
      index = (next + total) % total;
      if (slides.length) {
        slides.forEach(function (slide, i) { slide.classList.toggle('is-on', i === index); });
      } else {
        var src = thumbs[index] && thumbs[index].getAttribute('data-src');
        if (main && src) { main.src = src; main.srcset = src; }
      }
      syncActiveThumb(index);
    }
    var stageEl = root.querySelector('.ndp-stage');
    if (stageEl && slides.length > 1) {
      var startX = 0;
      var startY = 0;
      var swiping = false;
      stageEl.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1 || event.target.closest('.ndp-arrow')) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        swiping = true;
      }, { passive: true });
      stageEl.addEventListener('touchend', function (event) {
        if (!swiping) return;
        swiping = false;
        var touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
        showImage(index + (dx < 0 ? 1 : -1));
      }, { passive: true });
      stageEl.addEventListener('touchcancel', function () { swiping = false; }, { passive: true });
    }
    root.querySelectorAll('[data-ndp-prev]').forEach(function (button) { button.addEventListener('click', function () { showImage(index - 1); }); });
    root.querySelectorAll('[data-ndp-next]').forEach(function (button) { button.addEventListener('click', function () { showImage(index + 1); }); });
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { showImage(i); }); });

    function currentUnit() {
      var variant = variants[picks[0]] || selected;
      return variant ? variant.price : 0;
    }
    function paintBundles() {
      var unit = currentUnit();
      var activeTotal = unit * bundleQty;
      root.querySelectorAll('[data-bundle]').forEach(function (card) {
        var qty = Number(card.getAttribute('data-qty'));
        var payQty = Number(card.getAttribute('data-pay-qty') || qty);
        var fixedCents = Number(card.getAttribute('data-bundle-price-cents') || 0);
        var compareCents = Number(card.getAttribute('data-bundle-compare-cents') || 0);
        var totalCents = fixedCents > 0 ? fixedCents : unit * payQty;
        var on = qty === bundleQty;
        if (on) activeTotal = totalCents;
        card.classList.toggle('is-on', on);
        var price = card.querySelector('[data-bundle-price]');
        var compareNode = card.querySelector('[data-bundle-compare]');
        var unitNote = card.querySelector('[data-bundle-unit]');
        if (price) price.textContent = eur(totalCents);
        if (compareNode && compareCents > totalCents) compareNode.textContent = eur(compareCents);
        if (unitNote) unitNote.textContent = 'soit ' + eur(Math.round(totalCents / qty)) + ' l’unité';
      });
      var shadeRow = root.querySelector('[data-shade-row]');
      if (shadeRow) shadeRow.hidden = bundleQty > 1;
      var label = root.querySelector('[data-shade-label]');
      var names = [];
      for (var i = 0; i < bundleQty; i++) {
        var variant = variants[picks[i]] || variants[0];
        if (variant) names.push(variant.title);
      }
      var same = names.every(function (name) { return name === names[0]; });
      var shadeLabel = names.length ? (same ? names[0] + (names.length > 1 ? ' ×' + names.length : '') : names.join(' / ')) : '';
      if (label && names[0] && names[0] !== 'Default Title') label.textContent = shadeLabel;
      var stickyPrice = root.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = eur(activeTotal);
      root.querySelectorAll('[data-ndp-order-price]').forEach(function (node) {
        node.textContent = eur(activeTotal);
      });
      var stickyName = root.querySelector('[data-sticky-name]');
      if (stickyName) {
        var stickySuffix = names[0] === 'Default Title' ? (bundleQty > 1 ? ' ×' + bundleQty : '') : (shadeLabel ? ' — ' + shadeLabel : '');
        stickyName.textContent = root.getAttribute('data-title') + stickySuffix;
      }
    }
    function paintShades() {
      root.querySelectorAll('[data-shade]').forEach(function (button) {
        button.classList.toggle('is-on', Number(button.getAttribute('data-shade')) === picks[0]);
      });
    }
    function paintPicker(picker, value) {
      var option = picker.querySelector('[data-pick-option="' + value + '"]');
      if (!option) return;
      picker.querySelectorAll('[data-pick-option]').forEach(function (item) {
        var on = item === option;
        item.classList.toggle('is-on', on);
        item.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var dot = picker.querySelector('[data-pick-dot]');
      var name = picker.querySelector('[data-pick-name]');
      if (dot) dot.style.background = option.getAttribute('data-color');
      if (name && variants[value]) name.textContent = variants[value].title;
    }
    function paintThumbs() {
      var variant = variants[picks[0]] || selected;
      if (!variant || !variant.thumb) return;
      root.querySelectorAll('[data-bundle-thumb]').forEach(function (img) { img.src = variant.thumb; });
    }
    function setPick(slot, value) {
      picks[slot] = value;
      if (slot === 0) selected = variants[value];
      root.querySelectorAll('[data-pick="' + slot + '"]').forEach(function (picker) { paintPicker(picker, value); });
      paintThumbs();
      paintBundles();
    }
    function closePickers(except) {
      root.querySelectorAll('[data-pick].is-open').forEach(function (picker) {
        if (picker === except) return;
        picker.classList.remove('is-open');
        picker.querySelector('[data-pick-toggle]').setAttribute('aria-expanded', 'false');
        picker.querySelector('[role="listbox"]').hidden = true;
      });
    }
    root.querySelectorAll('[data-pick]').forEach(function (picker) {
      var toggle = picker.querySelector('[data-pick-toggle]');
      var list = picker.querySelector('[role="listbox"]');
      toggle.addEventListener('click', function () {
        var open = !picker.classList.contains('is-open');
        closePickers(picker);
        picker.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        list.hidden = !open;
      });
      picker.querySelectorAll('[data-pick-option]').forEach(function (option) {
        option.addEventListener('click', function () {
          setPick(Number(picker.getAttribute('data-pick')), Number(option.getAttribute('data-pick-option')));
          closePickers();
          toggle.focus();
        });
      });
    });
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-pick]')) closePickers();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePickers();
    });

    root.querySelectorAll('[data-shade]').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = Number(button.getAttribute('data-shade'));
        picks = picks.map(function () { return value; });
        selected = variants[value];
        root.querySelectorAll('[data-pick]').forEach(function (picker) { paintPicker(picker, value); });
        paintThumbs();
        paintShades();
        paintBundles();
        if (selected && selected.image && main) {
          main.src = selected.image;
          main.srcset = selected.image;
          showImage(0);
        }
      });
    });
    root.querySelectorAll('[data-bundle]').forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.target.closest('[data-pick]')) return;
        bundleQty = Number(card.getAttribute('data-qty'));
        paintBundles();
      });
    });
    var orderButtons = root.querySelectorAll('[data-ndp-order]');
    var upsell = document.querySelector('[data-nay-upsell]');
    function placeOrder() {
      var counts = {};
      for (var i = 0; i < bundleQty; i++) {
        var variant = variants[picks[i]] || variants[0];
        if (!variant) continue;
        counts[variant.id] = (counts[variant.id] || 0) + 1;
      }
      var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
      return addItems(items);
    }
    orderButtons.forEach(function (orderButton) {
      orderButton.addEventListener('click', function () {
        placeOrder().then(function () {
          if (upsell) upsell.classList.add('is-open');
          else openFunnel();
        });
      });
    });
    if (upsell) {
      upsell.querySelectorAll('[data-upsell-close]').forEach(function (button) {
        button.addEventListener('click', function () { upsell.classList.remove('is-open'); openFunnel(); });
      });
      var accept = upsell.querySelector('[data-upsell-accept]');
      if (accept) {
        accept.addEventListener('click', function () {
          addItems([{ id: Number(accept.getAttribute('data-upsell-accept')), quantity: 1 }]).then(function () {
            upsell.classList.remove('is-open');
            openFunnel();
          });
        });
      }
      var time = upsell.querySelector('[data-upsell-time]');
      if (time) {
        var left = 12 * 60 + 6;
        setInterval(function () {
          if (!upsell.classList.contains('is-open') || left <= 0) return;
          left -= 1;
          time.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
        }, 1000);
      }
    }

    var stories = root.querySelectorAll('[data-story]');
    var viewer = root.querySelector('[data-story-viewer]');
    var storyIndex = 0;
    var seen = {};
    var storyTimer;
    var storyStrip = root.querySelector('[data-stories]');
    var storyImage = viewer && viewer.querySelector('[data-story-image]');
    var storyVideo = viewer && viewer.querySelector('[data-story-video]');
    function closeStory() {
      if (!viewer) return;
      clearTimeout(storyTimer);
      viewer.hidden = true;
      if (storyVideo) {
        storyVideo.pause();
        storyVideo.onended = null;
        storyVideo.removeAttribute('src');
        storyVideo.load();
      }
      if (storyStrip) storyStrip.classList.remove('is-paused');
    }
    function openStory(i) {
      storyIndex = i;
      seen[i] = true;
      stories.forEach(function (bubble, n) { bubble.classList.toggle('is-seen', !!seen[n]); });
      if (!viewer) return;
      var story = stories[i];
      viewer.hidden = false;
      if (storyStrip) storyStrip.classList.add('is-paused');
      viewer.querySelector('[data-story-name]').textContent = story.getAttribute('data-name');
      viewer.querySelector('[data-story-tag]').textContent = story.getAttribute('data-tag');
      var storyBackdrop = story.getAttribute('data-image');
      viewer.querySelector('[data-story-tone]').style.background = storyBackdrop && !story.getAttribute('data-video') ? 'center / cover no-repeat url("' + storyBackdrop + '")' : story.getAttribute('data-tone');
      clearTimeout(storyTimer);
      var videoUrl = story.getAttribute('data-video');
      var imageUrl = story.getAttribute('data-image');
      if (storyVideo) {
        storyVideo.hidden = !videoUrl;
        storyVideo.onended = null;
        if (videoUrl) {
          storyVideo.loop = false;
          storyVideo.muted = false;
          storyVideo.src = videoUrl;
          var playing = storyVideo.play();
          if (playing && playing.catch) {
            playing.catch(function () {
              storyVideo.muted = true;
              storyVideo.play().catch(function () {});
            });
          }
        } else {
          storyVideo.pause();
          storyVideo.removeAttribute('src');
        }
      }
      if (storyImage) {
        storyImage.hidden = !!videoUrl || !imageUrl;
        if (!videoUrl && imageUrl) {
          storyImage.src = imageUrl;
          storyImage.style.animation = 'none';
          void storyImage.offsetWidth;
          storyImage.style.animation = '';
        }
      }
    }
    stories.forEach(function (bubble, i) { bubble.addEventListener('click', function () { openStory(i); }); });
    root.querySelectorAll('video.ndp-bubble__live').forEach(function (clip) {
      var start = function () { var playing = clip.play(); if (playing) playing.catch(function () {}); };
      start();
      clip.addEventListener('loadeddata', start);
    });
    root.querySelectorAll('[data-story-clone]').forEach(function (bubble) {
      bubble.addEventListener('click', function () { openStory(Number(bubble.getAttribute('data-story-clone'))); });
    });
    if (storyStrip) {
      storyStrip.addEventListener('touchstart', function () { storyStrip.classList.add('is-paused'); }, { passive: true });
      storyStrip.addEventListener('touchend', function () { if (!viewer || viewer.hidden) storyStrip.classList.remove('is-paused'); }, { passive: true });
    }
    if (viewer) {
      viewer.addEventListener('click', function (event) {
        if (event.target === viewer) closeStory();
      });
      viewer.querySelector('[data-story-close]').addEventListener('click', closeStory);
    }

    var timeline = root.querySelector('[data-timeline]');
    if (timeline) {
      var line = timeline.querySelector('[data-timeline-line]');
      var timelineTrack = timeline.querySelector('[data-timeline-track]');
      var steps = Array.prototype.slice.call(timeline.querySelectorAll('[data-step]'));
      var nodes = steps.map(function (step) { return step.querySelector('.ndp-node'); });
      var nodeCenter = function (node) { var r = node.getBoundingClientRect(); return r.top + r.height / 2; };
      var layoutTimeline = function () {
        if (!nodes.length || !nodes[0]) return;
        var top = timeline.getBoundingClientRect().top;
        var start = nodeCenter(nodes[0]) - top;
        var end = nodeCenter(nodes[nodes.length - 1]) - top;
        [line, timelineTrack].forEach(function (el) {
          if (!el) return;
          el.style.top = start + 'px';
          el.style.bottom = 'auto';
          el.style.height = Math.max(0, end - start) + 'px';
        });
      };
      var ticking = false;
      var onScroll = function () {
        ticking = false;
        var tip = window.innerHeight * 0.6;
        if (timelineTrack && line) {
          var r = timelineTrack.getBoundingClientRect();
          var progress = r.height ? Math.max(0, Math.min(1, (tip - r.top) / r.height)) : 0;
          line.style.transform = 'scaleY(' + progress + ')';
        }
        steps.forEach(function (step, i) {
          if (nodes[i]) step.classList.toggle('is-on', nodeCenter(nodes[i]) <= tip + 1);
        });
        var sticky = root.querySelector('[data-sticky]');
        if (sticky) sticky.classList.toggle('is-on', window.scrollY > 900);
      };
      var requestTick = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(onScroll);
      };
      layoutTimeline();
      onScroll();
      window.addEventListener('scroll', requestTick, { passive: true });
      window.addEventListener('resize', function () { layoutTimeline(); requestTick(); });
      window.addEventListener('load', function () { layoutTimeline(); requestTick(); });
    }

    var stats = root.querySelector('[data-stats]');
    if (stats && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        var start = performance.now();
        var run = function (now) {
          var t = Math.min(1, (now - start) / 1800);
          stats.querySelectorAll('[data-stat]').forEach(function (node, i) {
            var target = Number(node.getAttribute('data-stat'));
            var delay = i * 0.12;
            var k = Math.max(0, Math.min(1, (t - delay) / 0.64));
            var eased = 1 - Math.pow(1 - k, 3);
            node.querySelector('b').textContent = Math.round(eased * target);
            var ring = node.querySelector('circle.is-value');
            if (ring) {
              var c = 2 * Math.PI * 52;
              ring.style.strokeDashoffset = String(c * (1 - eased * target / 100));
            }
          });
          if (t < 1) requestAnimationFrame(run);
        };
        requestAnimationFrame(run);
      }, { threshold: 0.35 });
      observer.observe(stats);
    }
    paintShades();
    paintBundles();
  }

  document.querySelectorAll('[data-ndp]').forEach(initProduct);
  paintWish();
  loadCart();

  if ('IntersectionObserver' in window) {
    var ugcWatch = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        var src = video.getAttribute('data-ugc-src');
        if (!src) return;
        if (entry.isIntersecting) {
          if (video.getAttribute('src') !== src) video.src = src;
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px' });
    document.querySelectorAll('[data-ugc-src]').forEach(function (video) { ugcWatch.observe(video); });
  }

  document.querySelectorAll('[data-ndh-rail]').forEach(function (rail) {
    var scroller = rail.querySelector('[data-ndh-scroller]');
    var prev = rail.querySelector('[data-ndh-rail-btn="prev"]');
    var next = rail.querySelector('[data-ndh-rail-btn="next"]');
    if (!scroller) return;
    var sync = function () {
      var max = scroller.scrollWidth - scroller.clientWidth - 4;
      if (prev) prev.disabled = scroller.scrollLeft <= 4;
      if (next) next.disabled = max <= 0 || scroller.scrollLeft >= max;
    };
    scroller.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  var leadModal = document.querySelector('[data-nay-lead]');
  var leadPill = document.querySelector('[data-nay-lead-open]');
  if (leadModal) {
    var leadKey = 'nay-lead-state';
    var leadCode = leadModal.getAttribute('data-code') || 'BIENVENUE5';
    var leadForm = leadModal.querySelector('form');
    var stepForm = leadModal.querySelector('[data-nay-lead-step="form"]');
    var stepDone = leadModal.querySelector('[data-nay-lead-step="done"]');
    var copyBtn = leadModal.querySelector('[data-nay-lead-copy]');
    var savedState = '';
    try { savedState = localStorage.getItem(leadKey) || ''; } catch (e) {}

    var applyDiscountCookie = function (code) {
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
    };

    var openLead = function () {
      leadModal.hidden = false;
      if (leadPill) leadPill.hidden = true;
      // La page ne doit pas defiler derriere la fenetre.
      document.body.style.overflow = 'hidden';
      var firstField = leadModal.querySelector('input[type="email"], [data-nay-lead-close]');
      if (firstField) { try { firstField.focus({ preventScroll: true }); } catch (e) { firstField.focus(); } }
    };

    var closeLead = function () {
      leadModal.hidden = true;
      document.body.style.overflow = '';
      try {
        if (localStorage.getItem(leadKey) !== 'subscribed') {
          localStorage.setItem(leadKey, 'dismissed');
          if (leadPill) leadPill.hidden = false;
        }
      } catch (e) {}
    };

    var showLeadSuccess = function () {
      if (stepForm) stepForm.hidden = true;
      if (stepDone) stepDone.hidden = false;
      try { localStorage.setItem(leadKey, 'subscribed'); } catch (e) {}
      if (leadPill) leadPill.hidden = true;
      applyDiscountCookie(leadCode);
      openLead();
    };

    if ( (stepDone && !stepDone.hidden) || location.search.indexOf('customer_posted=true') !== -1 ) {
      showLeadSuccess();
    } else if (savedState === 'subscribed') {
      applyDiscountCookie(leadCode);
    } else if (savedState === 'dismissed') {
      if (leadPill) leadPill.hidden = false;
    } else {
      // Ouverture : 15 s OU intention de sortie. Jamais par-dessus le bandeau
      // cookies, jamais par-dessus le panier. Si le bandeau est encore affiche,
      // on repousse l'ouverture au lieu d'empiler deux fenetres.
      var leadArmed = true;

      // Shopify rend le bandeau de consentement tantot par id, tantot par
      // classe, et le laisse dans le DOM en display:none une fois le choix
      // fait : on teste les deux et on verifie qu'il occupe vraiment l'ecran.
      var cookieBannerSelectors = ['#shopify-pc__banner', '.shopify-pc__banner'];
      var cookieBannerVisible = function () {
        for (var i = 0; i < cookieBannerSelectors.length; i++) {
          var banner = document.querySelector(cookieBannerSelectors[i]);
          if (!banner || banner.hidden) continue;
          var style = window.getComputedStyle(banner);
          if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') continue;
          if (banner.getBoundingClientRect().height > 0) return true;
        }
        return false;
      };

      // La popup passe au-dessus de tout (z-index tres eleve) : on refuse de
      // l'ouvrir tant qu'autre chose occupe l'ecran ou que la cliente est en
      // train de commander.
      var somethingElseOpen = function () {
        if (funnel && funnel.classList.contains('is-open')) return true;
        var blockers = document.querySelectorAll('[data-nay-upsell], [data-story-viewer], [data-nay-toast].is-on');
        for (var i = 0; i < blockers.length; i++) {
          if (blockers[i].classList.contains('is-open') || blockers[i].classList.contains('is-on')) return true;
        }
        return false;
      };

      // Pages ou la cliente est en train de payer : on ne l'interrompt pas.
      var onCheckoutPath = /^\/(cart|checkout)/.test(window.location.pathname);

      var canOpenLead = function () {
        if (!leadArmed || !leadModal.hidden) return false;
        if (onCheckoutPath) return false;
        if (somethingElseOpen()) return false;
        if (cookieBannerVisible()) return false;
        return true;
      };

      var tryOpenLead = function () {
        if (!canOpenLead()) return;
        leadArmed = false;
        openLead();
      };

      // 1) Apres 15 s. Si le bandeau cookies est encore la, on reessaie
      //    toutes les 2 s (20 fois max, soit 40 s) puis on abandonne.
      setTimeout(function () {
        tryOpenLead();
        if (!leadArmed) return;
        var tries = 0;
        var retry = setInterval(function () {
          tries += 1;
          tryOpenLead();
          if (!leadArmed || tries >= 20) clearInterval(retry);
        }, 2000);
      }, 15000);

      // 2) Intention de sortie : la souris quitte la page par le haut, mais
      //    pas dans les 8 premieres secondes (sinon un simple aller-retour
      //    vers la barre d'adresse declenche la popup immediatement).
      var exitIntentReady = false;
      setTimeout(function () { exitIntentReady = true; }, 8000);
      document.addEventListener('mouseout', function (event) {
        if (!exitIntentReady) return;
        if (event.relatedTarget || event.toElement) return;
        if (event.clientY > 0) return;
        tryOpenLead();
      });
    }

    leadModal.querySelectorAll('[data-nay-lead-close]').forEach(function (btn) {
      btn.addEventListener('click', closeLead);
    });
    if (leadPill) {
      leadPill.addEventListener('click', openLead);
    }
    // Fermeture au clavier.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.keyCode !== 27) return;
      if (leadModal.hidden) return;
      closeLead();
    });
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(leadCode).catch(function () {});
        }
        copyBtn.textContent = 'Copié !';
        setTimeout(function () { copyBtn.textContent = 'Copier'; }, 2200);
      });
    }
    if (leadForm) {
      leadForm.addEventListener('submit', function (event) {
        var emailInput = leadForm.querySelector('input[type="email"]');
        if (!emailInput || !emailInput.value) return;
        event.preventDefault();
        var submitBtn = leadForm.querySelector('.nay-lead__submit');
        var submitLabel = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Activation…';
        }
        // On n'annonce "c'est debloque" que si l'inscription a vraiment abouti.
        // Sinon la cliente attend un e-mail qui n'arrivera jamais.
        var leadFailed = function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitLabel;
          }
          var errNode = leadModal.querySelector('.nay-lead__err');
          if (!errNode) {
            errNode = document.createElement('p');
            errNode.className = 'nay-lead__err';
            if (emailInput.parentNode) emailInput.parentNode.insertBefore(errNode, emailInput);
          }
          errNode.textContent = 'Votre inscription n’a pas pu être enregistrée. Réessayez dans un instant.';
        };
        var body = new URLSearchParams(new FormData(leadForm)).toString();
        fetch(leadForm.getAttribute('action') || '/contact#nay-lead-form', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body,
          credentials: 'same-origin'
        }).then(function (response) {
          if (response && response.ok === false) {
            leadFailed();
            return;
          }
          showLeadSuccess();
        }).catch(leadFailed);
      });
    }
  }
})();
